import { Link } from "react-router-dom";

export default function EditProfilePanel({ formState, errors, onChange, onSubmit, onReset }) {
  return (
    <section className="mt-6">
      <p className="text-[var(--color-text-muted)] xl:text-sm text-xs font-bold uppercase tracking-[0.08em] mb-4">
        Edit Profile
      </p>
      <form className="relative bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4" onSubmit={onSubmit}>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-4 items-start">
          <div>
            <label htmlFor="first_name" className="md:text-sm text-xs label-caps block mb-2">
              First Name <span className="text-[var(--color-accent-red)] ml-1 font-bold">*</span>
            </label>
            <input
              id="first_name"
              autoComplete="family-name"
              type="text"
              className={`w-full py-3 px-4 bg-[var(--color-bg)] border rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none ${
                errors?.firstName
                  ? "border-[rgba(255,69,0,0.25)]"
                  : "border-[var(--color-border)]"
              }`}
              value={formState.firstName}
              onChange={(event) => onChange("firstName", event.target.value)}
              placeholder="First name"
            />
            {errors?.firstName && <span className="md:text-sm text-xs mt-1 text-[var(--color-accent-red)]">{errors.firstName}</span>}
          </div>

          <div>
            <label htmlFor="last_name" className="md:text-sm text-xs label-caps block mb-2">
              Last Name <span className="text-[var(--color-accent-red)] ml-1 font-bold">*</span>
            </label>
            <input
              id="last_name"
              autoComplete="family-name"
              type="text"
              className={`w-full py-3 px-4 bg-[var(--color-bg)] border rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none ${
                errors?.lastName
                  ? "border-[rgba(255,69,0,0.25)]"
                  : "border-[var(--color-border)]"
              }`}
              value={formState.lastName}
              onChange={(event) => onChange("lastName", event.target.value)}
              placeholder="Last name"
            />
            {errors?.lastName && <span className="md:text-sm text-xs mt-1 text-[var(--color-accent-red)]">{errors.lastName}</span>}
          </div>

          <div>
            <label htmlFor="email" className="md:text-sm text-xs label-caps block mb-2">Email</label>
            <input
              id="email"
              autoComplete="email"
              type="email"
              className="w-full py-3 px-4 bg-[var(--color-bg)] border border-[var(--color-border)] rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none opacity-60 cursor-not-allowed"
              value={formState.email}
              disabled
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label htmlFor="location" className="md:text-sm text-xs label-caps block mb-2">Location</label>
            <input
              id="location"
              autoComplete="off"
              type="text"
              className="w-full py-3 px-4 bg-[var(--color-bg)] border border-[var(--color-border)] rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none"
              value={formState.location}
              onChange={(event) => onChange("location", event.target.value)}
              placeholder="Melbourne, AUS"
            />
          </div>
        </div>

        <div className="text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs md:mt-5 mt-4">
          Saved changes update the profile stored on this device.
        </div>

        <div className="flex justify-end gap-4 mt-7 md:flex-row flex-col-reverse">
          <button
            type="button"
            className="appearance-none md:w-auto w-full xl:text-base md:text-sm text-xs bg-transparent text-[var(--color-primary)] border border-[var(--color-border)] p-3 rounded-[var(--radius-md)] font-extrabold uppercase tracking-[0.06em] cursor-pointer"
            onClick={onReset}
          >
            Reset
          </button>
          <button type="submit" className="appearance-none md:w-auto w-full xl:text-base md:text-sm text-xs bg-[var(--color-primary)] text-black border-none p-3 rounded-[var(--radius-md)] font-extrabold uppercase tracking-[0.06em] cursor-pointer">
            Save Changes
          </button>
        </div>
      </form>

      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 mt-6">
        <h3 className="xl:text-2xl md:text-xl text-lg font-bold text-[var(--color-text)] mb-2">Manage Account</h3>
        <p className="text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs mb-5">
          In this section, you can configure options related to your account. If you wish to delete your account will be deactivated immediately, and you can recover it within 30 days by logging back in. After 30 days, the deletion becomes permanent and cannot be undone.
        </p>
        <Link
          to="/delete-account"
          className="appearance-none inline-flex items-center md:w-auto w-full xl:text-base md:text-sm text-xs bg-[rgba(255,69,0,0.12)] border border-[rgba(255,69,0,0.25)] text-[var(--color-accent-red)] p-3 rounded-[var(--radius-md)] font-extrabold uppercase tracking-[0.06em] cursor-pointer"
        >
          Delete Account
        </Link>
      </div>
    </section>
  );
}
